module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap user"
  }, [_c('div', {
    staticClass: "banner user-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.user.avatar,
      "alt": _vm.user.nickname
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.user.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "signature"
  }, [_vm._v("\n                    " + _vm._s(_vm.user.signature) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/user/report'
      },
      "tag": "a",
      "active-class": "active"
    }
  }, [_vm._v("我的报告")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/user/evaluates'
      },
      "tag": "a",
      "active-class": "active"
    }
  }, [_vm._v("我的测评")]), _vm._v(" "), (_vm.user.category === 1 && _vm.user.role === 1) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/user/join-company'
      },
      "tag": "a",
      "active-class": "active"
    }
  }, [_vm._v("关联企业")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/user/setting'
      },
      "tag": "a",
      "active-class": "active"
    }
  }, [_vm._v("个人设置")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-t-md"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "min-height": "520px"
    }
  }, [_c('router-view')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fac9b946","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/user.vue
// module id = 505
// module chunks = 1